export const FETCH_TEXT_TEMPLATES_START = 'FETCH_TEXT_TEMPLATES_START';
export const FETCH_TEXT_TEMPLATES_SUCCESS = 'FETCH_TEXT_TEMPLATES_SUCCESS';
export const FETCH_TEXT_TEMPLATES_FAIL = 'FETCH_TEXT_TEMPLATES_FAIL';

export const CREATE_TEXT_TEMPLATE_START = 'CREATE_TEXT_TEMPLATE_START';
export const CREATE_TEXT_TEMPLATE_SUCCESS = 'CREATE_TEXT_TEMPLATE_SUCCESS';
export const CREATE_TEXT_TEMPLATE_FAIL = 'CREATE_TEXT_TEMPLATE_FAIL';

export const UPDATE_TEXT_TEMPLATE_START = 'UPDATE_TEXT_TEMPLATE_START';
export const UPDATE_TEXT_TEMPLATE_SUCCESS = 'UPDATE_TEXT_TEMPLATE_SUCCESS';
export const UPDATE_TEXT_TEMPLATE_FAIL = 'UPDATE_TEXT_TEMPLATE_FAIL';

export const DELETE_TEXT_TEMPLATE_START = 'DELETE_TEXT_TEMPLATE_START';
export const DELETE_TEXT_TEMPLATE_SUCCESS = 'DELETE_TEXT_TEMPLATE_SUCCESS';
export const DELETE_TEXT_TEMPLATE_FAIL = 'DELETE_TEXT_TEMPLATE_FAIL';

export const DUPLICATE_TEXT_TEMPLATE_START = 'DUPLICATE_TEXT_TEMPLATE_START';
export const DUPLICATE_TEXT_TEMPLATE_SUCCESS =
  'DUPLICATE_TEXT_TEMPLATE_SUCCESS';
export const DUPLICATE_TEXT_TEMPLATE_FAIL = 'DUPLICATE_TEXT_TEMPLATE_FAIL';

export const RESET_TEXT_TEMPLATE_STORE = 'RESET_TEXT_TEMPLATE_STORE';
export const RESET_TEXT_TEMPLATE_CREATE_STORE =
  'RESET_TEXT_TEMPLATE_CREATE_STORE';

export const LOGOUT = 'LOGOUT';

export type TextTemplateActionTypes =
  | typeof FETCH_TEXT_TEMPLATES_START
  | typeof FETCH_TEXT_TEMPLATES_SUCCESS
  | typeof FETCH_TEXT_TEMPLATES_FAIL
  | typeof CREATE_TEXT_TEMPLATE_START
  | typeof CREATE_TEXT_TEMPLATE_SUCCESS
  | typeof CREATE_TEXT_TEMPLATE_FAIL
  | typeof UPDATE_TEXT_TEMPLATE_START
  | typeof UPDATE_TEXT_TEMPLATE_SUCCESS
  | typeof UPDATE_TEXT_TEMPLATE_FAIL
  | typeof DELETE_TEXT_TEMPLATE_START
  | typeof DELETE_TEXT_TEMPLATE_SUCCESS
  | typeof DELETE_TEXT_TEMPLATE_FAIL
  | typeof DUPLICATE_TEXT_TEMPLATE_START
  | typeof DUPLICATE_TEXT_TEMPLATE_SUCCESS
  | typeof DUPLICATE_TEXT_TEMPLATE_FAIL
  | typeof RESET_TEXT_TEMPLATE_STORE
  | typeof RESET_TEXT_TEMPLATE_CREATE_STORE
  | typeof LOGOUT;
